import React, { Fragment, useState, useContext } from "react";
import { Outlet, Link } from "react-router-dom";
import HandWrittenLogo from "../UI/HandWrittenLogo";
import AboutOverlay from "../AboutOverlay/AboutOverlay";
import LocalizationJSON from "../../localization/localization.json";
import { isMobile } from "react-device-detect";
import { LanguageContext } from "../../App";
import classes from "./HeaderBar.module.css";
import { AppHelper } from "../../App";

function HeaderBar(props) {
  let localizationJSON = LocalizationJSON;
  let langcontext = useContext(LanguageContext);

  const [viewAboutOverlay, setViewAboutOverlay] = useState(false);

  function switchOverlay() {
    setViewAboutOverlay(!viewAboutOverlay);
  }

  return (
    <Fragment>
      <div className={classes.header}>
        <div className={classes.bar}>
          <div className={classes.title}>
            <Link to="/">
              <div className={classes.logo}>
                <HandWrittenLogo></HandWrittenLogo>
              </div>
            </Link>
          </div>
          {
            // if Mobile then don't show 'LangSelect'
            isMobile ? null : (
              <div
                className={classes.languageitem}
                onClick={props.toggleLanguage}
              >
                <div
                  style={{
                    color:
                      langcontext === "pl" ? "black" : "rgba(0, 0, 0, 0.204)",
                  }}
                >
                  PL
                </div>

                <div
                  style={{
                    color:
                      langcontext === "en" ? "black" : "rgba(0, 0, 0, 0.204)",
                    marginLeft: "5px",
                  }}
                >
                  EN
                </div>
              </div>
            )
          }

          {
            // if Mobile then don't show 'About'
            isMobile ? null : (
              <div className={classes.aboutitem}>
                <div onClick={switchOverlay}>
                  {AppHelper.ReturnLanguageContent(
                    localizationJSON.headerbar_about,
                    langcontext
                  )}
                </div>
              </div>
            )
          }
        </div>
      </div>

      {viewAboutOverlay ? (
        <AboutOverlay
          viewAboutOverlay={viewAboutOverlay}
          switchOverlay={switchOverlay}
        />
      ) : null}

      <Outlet></Outlet>
    </Fragment>
  );
}

export default HeaderBar;
